module.exports = __webpack_public_path__ + "img/Octocat.1cfa76e9.png";